import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import Snackbar from '../../components/snackbar/Snackbar';
import { Box, Modal, Skeleton } from '@mui/material';
import TextareaAutosize from 'react-textarea-autosize';
import { gsap } from 'gsap';
import Cookies from 'js-cookie';
import { Link } from 'react-router-dom';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useQuery } from 'react-query';
import Fancybox from './fancybox';
import config from '../../config';

gsap.registerPlugin(ScrollTrigger);

const fetchUserData = async (activeUserId) => {
  if (!activeUserId) {
    return null;
  }

  const url = `${config.apiBaseUrl}admins/users/${activeUserId}/business-profiles`;

  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${Cookies.get('authToken')}`
  };

  const response = await axios.get(url, { headers });
  return response.data;
};

const fetchUserSubscriptions = async (activeUserId) => {
  if (!activeUserId) {
    return null;
  }

  const url = `${config.apiBaseUrl}admins/subscriptions/${activeUserId}`;

  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${Cookies.get('authToken')}`
  };

  const response = await axios.get(url, { headers });
  return response.data;
};

const PromotionsPageBlockNew = ({
  refetch,
  loading,
  blockStatus,
  email,
  promationImg,
  promationSite,
  promationDate,
  promationBudget,
  promationDailyBudget,
  promationDuration,
  promationAction,
  promationLocation,
  promationPrimaryText,
  promationHeadlineText,
  promationId,
  promationRejectTitle,
  promationRejectedAt,
  promationRejectDescription,
  adminEmail,
  setActivePage,
  activePage,
  promationTotal,
  activeUserId,
  leadFormUrl,
  promationTime,
  promationAds,
  promationData
}) => {
  const role = Cookies.get('role');

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarText, setSnackbarText] = useState('Advertisement successfully published');
  const [snackbarCount, setSnackbarCount] = useState(3);
  const [buttonLoading, setButtonLoading] = useState(false);

  const styleBlock = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 595,
    outline: 'none'
  };
  const styleReject = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 643,
    outline: 'none'
  };

  const [openBlock, setOpenBlock] = useState(false);

  const handleCloseBlock = () => {
    setOpenBlock(false);
  };

  const handleOpenBlock = () => {
    setOpenBlock(true);
  };

  const [openReject, setOpenReject] = useState(false);

  const handleCloseReject = (event) => {
    buttonAnimation(event.target);
    setTimeout(() => {
      setOpenReject(false);
    }, 300);
  };

  const handleOpenReject = (event) => {
    buttonAnimation(event.target);
    setOpenReject(true);
  };

  const [openEdit, setOpenEdit] = useState(false);

  const [promationDataEdit, setPromotionDataEdit] = useState(promationData);

  const [urlEdit, setUrlEdit] = useState('');
  const [errorUrl, setErrorUrl] = useState('');

  const handleChange = (event) => {
    const value = event.target.value;
    setUrlEdit(value);
  };

  const handleOpenEdit = (event) => {
    updateStatus({
      ...promationData,
      status: 'PROCESSING'
    });
    buttonAnimation(event.target);
    setOpenEdit(true);
  };

  const handleCloseEdit = (event) => {
    buttonAnimation(event.target);
    setOpenEdit(false);
    updateStatus({
      ...promationData,
      status: promationData.status
    });
  };

  const handleSaveEdit = (event) => {
    const urlPattern = /^(https?:\/\/)?([\w\d-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/;
    if (!urlPattern.test(urlEdit)) {
      setErrorUrl('Please enter a valid URL.');
    } else {
      setErrorUrl('');
      buttonAnimation(event.target);
      setOpenEdit(false);

      updateStatus({
        ...promationData,
        body: {
          ...promationData.body,
          websiteUrl: urlEdit
        },
        status: promationData.status
      });
      refetch();
    }
  };

  const updateStatus = async (dataEdit) => {
    const url = `${config.apiBaseUrl}admins/facebook-ads/${promationId}`;
    const data = dataEdit;

    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${Cookies.get('authToken')}`
    };

    try {
      const response = await axios.patch(url, dataEdit, { headers });
    } catch (error) {
      updateStatus({
        ...promationData,
        status: promationData.status
      });
      console.error('Error updating status:', error);
    }
  };

  const [openRejectView, setOpenRejectView] = useState(false);

  const handleCloseRejectView = () => {
    setOpenRejectView(false);
  };

  const handleOpenRejectView = () => {
    setOpenRejectView(true);
  };

  const buttonAnimation = (element) => {
    const tl = gsap.timeline();
    tl.to(element, {
      duration: 0.085,
      scale: 0.85,
      opacity: 0.85,
      ease: 'power4.out'
    });
    tl.to(element, {
      duration: 0.55,
      scale: 1,
      opacity: 1,
      ease: 'elastic.out(1,0.6)'
    });
  };

  const handleClick = (event) => {
    buttonAnimation(event.target);
    startAds(promationId);
  };
  const [rejectLoading, setRejectLoading] = useState(false);

  const handleReject = (event) => {
    buttonAnimation(event.target);
    rejectAds(promationId);
  };

  const [errorText, setErrorText] = useState('');

  const startAds = (id) => {
    setButtonLoading(true);
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${Cookies.get('authToken')}`
    };
    axios
      .patch(
        `${config.apiBaseUrl}admins/facebook-ads/${id}/start`,
        {},
        {
          headers
        }
      )
      .then((response) => {
        setButtonLoading(false);
        setSnackbarOpen(true);
        refetch();
      })
      .catch((error) => {
        setButtonLoading(false);
        setOpenBlock(true);
        setErrorText(error.response.data.message);
      });
  };

  const skipAds = () => {
    // setButtonLoading(true)
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${Cookies.get('authToken')}`
    };

    const params = {};
    axios
      .patch(
        `${config.apiBaseUrl}admins/facebook-ads/${promationId}`,
        { status: 'SKIPED' },
        {
          headers
        }
      )
      .then((response) => {
        // setButtonLoading(false)
        // setSnackbarOpen(true)
        refetch();
      })
      .catch((error) => {
        // setButtonLoading(false)
        setOpenBlock(true);
        setErrorText(error.response.data.message);
      });
  };

  const [reason, setReason] = useState('');
  const [description, setDescription] = useState('');

  const handleReasonChange = (event) => {
    const inputText = event.target.value;
    if (inputText.length <= 120) {
      setReason(inputText);
    }
  };

  const handleDescriptionChange = (event) => {
    const inputText = event.target.value;
    if (inputText.length <= 500) {
      setDescription(inputText);
    }
  };

  const rejectAds = (id) => {
    setRejectLoading(true);
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${Cookies.get('authToken')}`
    };
    axios
      .patch(
        `${config.apiBaseUrl}admins/facebook-ads/${id}/reject`,
        {
          rejectTitle: reason,
          rejectDescription: description
        },
        {
          headers
        }
      )
      .then((response) => {
        setRejectLoading(false);
        setSnackbarOpen(true);
        setOpenReject(false);
        refetch();
      })
      .catch((error) => {
        setRejectLoading(false);
        setOpenBlock(true);
        setOpenReject(false);
        setErrorText(error.response.data.message);
      });
  };

  const handleEdit = (event) => {
    buttonAnimation(event.target);
  };

  const handleSkip = (event) => {
    if (promationTotal == activePage) {
      setActivePage(1);
    } else {
      setActivePage(activePage + 1);
    }
    buttonAnimation(event.target);
  };

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    // width: 1473,
    width: '475rem',
    outline: 'none'
  };

  const [open, setOpen] = useState(false);
  const [img, setImg] = useState('');

  const handleOpen = (img) => {
    setOpen(true);
    setImg(img);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const sendWeb = (website) => {
    window.open(website, '_blank');
  };

  const openUser = (id) => {
    window.open(`/users?activeUserId=${id}`, '_blank');
  };

  const handleCopyClick = (value, text) => {
    navigator.clipboard
      .writeText(Object.values(value)[0])
      .then(() => {
        setSnackbarText(`${text} was copied`);
        setSnackbarCount(3);
        setSnackbarOpen(true);
      })
      .catch((error) => {
        console.error('Copy failed: ', error);
      });
  };

  const stickyRef = useRef(null);
  const containerRef = useRef(null);
  useEffect(() => {
    if (!loading) {
      const stickyElement = stickyRef.current;
      const stickyContainer = containerRef.current;

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: stickyElement,
          start: 'top top',
          end: `top+=${stickyContainer.offsetHeight} top`,
          pin: true
          // markers: true
        }
      });
      return () => {
        tl.kill();
      };
    }
  }, [loading]);

  const [brandName, setBrandName] = useState('');
  const {
    isLoading: isLoading,
    error: error,
    data: aboutData
  } = useQuery(['userAbout', activeUserId], () => fetchUserData(activeUserId));
  useEffect(() => {
    if (!isLoading && !error && aboutData) {
      if (aboutData.items[0]) {
        if (aboutData.items[0].companyName) {
          setBrandName(aboutData.items[0].companyName);
        } else {
          setBrandName('-');
        }
      }
    }
  }, [isLoading, error, aboutData]);

  const colorMap = {
    a: 'red',
    b: 'green',
    c: 'blue',
    d: 'violet',
    e: 'yellow',
    f: 'orange',
    g: 'brown',
    h: 'indigo',
    i: 'cadetblue',
    j: 'chocolate',
    k: 'crimson',
    l: 'darkcyan',
    m: 'darkgrey',
    n: 'darkolivegreen',
    o: 'darkorange',
    p: 'darkviolet',
    q: 'deeppink',
    r: 'fuchsia',
    s: 'gold',
    t: 'greenyellow',
    u: 'khaki',
    v: 'springgreen',
    w: 'yellowgreen',
    x: 'sienna',
    y: 'royalblue',
    z: 'peachpuff'
  };
  const firstLetter = brandName.charAt(0).toLowerCase();
  const textColor = colorMap[firstLetter] || 'violet';

  const [loadedImages, setLoadedImages] = useState([]);

  const [loaded, setLoaded] = useState([false, false, false]);

  useEffect(() => {
    if (promationAds.length > 0) {
      setLoadedImages(promationAds.map(() => [false, false, false]));
    }
    setLoaded([false, false, false]);
  }, [promationAds]);

  const handleImagesLoad = (adIndex, imageIndex) => {
    setLoadedImages((prev) => {
      const newLoadedImages = [...prev];
      newLoadedImages[adIndex][imageIndex] = true;
      return newLoadedImages;
    });
  };

  const handleImageLoad = (index) => {
    setLoaded((prev) => {
      const newLoaded = [...prev];
      newLoaded[index] = true;
      return newLoaded;
    });
  };

  const {
    isLoading: isLoadingSubscriptions,
    error: errorSubscriptions,
    data: infoSubscriptions
  } = useQuery(['userSubscriptions', activeUserId], () => fetchUserSubscriptions(activeUserId));

  return (
    <>
      {loading ? (
        <div className="promotionsPage-loader">
          <div className="spin-loader ios-loader">
            <div className="bar bar1"></div>
            <div className="bar bar2"></div>
            <div className="bar bar3"></div>
            <div className="bar bar4"></div>
            <div className="bar bar5"></div>
            <div className="bar bar6"></div>
            <div className="bar bar7"></div>
            <div className="bar bar8"></div>
          </div>
        </div>
      ) : (
        <div className="promotionsPage promotionsPageNew" ref={containerRef}>
          <div className="promotionsPageNew-top" ref={stickyRef}>
            <div className="userInfo-block-item" style={{ width: '160rem' }}>
              <span>Creation date</span>
              {loading ? (
                <Skeleton
                  variant="rounded"
                  width={'100%'}
                  height={23.4}
                  style={{ marginBottom: '0' }}
                />
              ) : (
                <p>
                  {promationDate}, {promationTime}
                </p>
                // <input type="text" value={promationDate} />
              )}
            </div>

            <div className="userInfo-block-item" style={{ width: '180rem' }}>
              <span>User email</span>
              {loading ? (
                <Skeleton
                  variant="rounded"
                  width={'100%'}
                  height={23.4}
                  style={{ marginBottom: '0' }}
                />
              ) : (
                <>
                  {' '}
                  <p>{email}</p>
                  <div className="table-tooltip-info">
                    <Link />
                    {email}
                    <div
                      className="table-tooltip-info-open table-tooltip-info__btn"
                      onClick={() => handleCopyClick({ email }, 'User email')}
                    >
                      Copy
                    </div>
                    <div
                      className="table-tooltip-info-copy table-tooltip-info__btn"
                      onClick={() => openUser(activeUserId)}
                    >
                      Open user profile
                    </div>
                  </div>
                </>

                // <input type="text" value={email} />
              )}
            </div>

            <div className="userInfo-block-item" style={{ width: '170rem' }}>
              <span>Website link</span>
              {loading ? (
                <Skeleton
                  variant="rounded"
                  width={'100%'}
                  height={23.4}
                  style={{ marginBottom: '0' }}
                />
              ) : (
                <div>
                  <p>
                    <a href={promationSite} target="_blank">
                      {promationSite}
                    </a>
                  </p>
                  <div className="table-tooltip-info">
                    {promationSite}
                    <div
                      className="table-tooltip-info-open table-tooltip-info__btn"
                      onClick={() => handleCopyClick({ promationSite }, 'Website link')}
                    >
                      Copy
                    </div>
                    <div className="table-tooltip-info-copy table-tooltip-info__btn">
                      Regenerate
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="userInfo-block-item" style={{ width: '170rem' }}>
              <span>Promotion page</span>
              {loading ? (
                <Skeleton
                  variant="rounded"
                  width={'100%'}
                  height={23.4}
                  style={{ marginBottom: '0' }}
                />
              ) : (
                <div>
                  <p>
                    <a href={leadFormUrl} target="_blank">
                      {leadFormUrl}
                    </a>
                  </p>
                  <div className="table-tooltip-info">
                    <Link />
                    {leadFormUrl}
                    <div
                      className="table-tooltip-info-open table-tooltip-info__btn"
                      onClick={() => handleCopyClick({ leadFormUrl }, 'Promotion page')}
                    >
                      Copy
                    </div>
                    <div
                      className="table-tooltip-info-copy table-tooltip-info__btn"
                      //  onClick={() => handleCopyClick(row.website, 'Site address')}
                    >
                      Regenerate
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className="userInfo-block-item">
              <span>Budget</span>
              {loading ? (
                <Skeleton
                  variant="rounded"
                  width={'100%'}
                  height={23.4}
                  style={{ marginBottom: '0' }}
                />
              ) : (
                <p>
                  ${typeof promationBudget === 'number' ? promationBudget.toFixed(2) : ''} ($
                  {typeof promationBudget === 'number'
                    ? (
                        promationBudget *
                        (infoSubscriptions?.data?.subscription?.bundleStatus === 'ACTIVE'
                          ? 1.06
                          : 1.12)
                      ).toFixed(2)
                    : ''}
                  )
                </p>
                // <input type="text" value={`$${typeof promationBudget === 'number' ? promationBudget.toFixed(2) : ''}`} />
              )}
            </div>
            <div className="userInfo-block-item">
              <span style={{ whiteSpace: 'nowrap' }}>Daily budget</span>
              {loading ? (
                <Skeleton
                  variant="rounded"
                  width={'100%'}
                  height={23.4}
                  style={{ marginBottom: '0' }}
                />
              ) : (
                <p>
                  ${typeof promationDailyBudget === 'number' ? promationDailyBudget.toFixed(2) : ''}
                </p>
                // <input type="text" value={`$${typeof promationBudget === 'number' ? promationBudget.toFixed(2) : ''}`} />
              )}
            </div>
            <div className="userInfo-block-item" style={{ width: '110rem' }}>
              <span>Duration</span>
              {loading ? (
                <Skeleton
                  variant="rounded"
                  width={'100%'}
                  height={23.4}
                  style={{ marginBottom: '0' }}
                />
              ) : (
                <p>{promationDuration} days</p>
                // <input type="text" value={`${promationDuration} days`} />
              )}
            </div>

            <div
              className="userInfo-block-item userInfo-block-item--location"
              style={{ width: '160rem' }}
            >
              <span>Locations</span>
              {loading ? (
                <Skeleton
                  variant="rounded"
                  width={'100%'}
                  height={23.4}
                  style={{ marginBottom: '0' }}
                />
              ) : (
                <div>
                  <p>{promationLocation}</p>
                  <div className="table-tooltip-info">
                    <span>{promationLocation}</span>

                    <div
                      className="table-tooltip-info-copy table-tooltip-info__btn"
                      onClick={() => handleCopyClick({ promationLocation }, 'Locations')}
                    >
                      Copy
                    </div>
                  </div>
                </div>

                // <input type="text" value={promationLocation} />
              )}
            </div>
          </div>

          <div className="promotionsPageNew-content">
            <div className="promotionsPageNew-content-item">
              <div className="promotionsPageNew-content-item__title">Advertisement 1</div>

              {promationAds.length > 0 ? (
                <>
                  {promationAds.map((ad, index) => (
                    <>
                      <Fancybox>
                        <div className="promotionsPageNew-creatives">
                          {ad.images && ad.images.length > 0 && (
                            <>
                              <div
                                className="promotionsPageNew-creatives-img"
                                style={{ aspectRatio: '1/1' }}
                              >
                                {loadedImages[index] && (
                                  <>
                                    {!loadedImages[index][0] && (
                                      <Skeleton
                                        variant="rounded"
                                        width="100%"
                                        height="100%"
                                        style={{ marginBottom: '0' }}
                                      />
                                    )}
                                    {ad.images && ad.images.length > 0 && (
                                      <a
                                        data-fancybox="gallery"
                                        href={ad.images[0].url}
                                        data-primaryText={ad.primaryText}
                                        data-headline={ad.headline}
                                        data-actionButton={ad.actionButton}
                                        data-brandName={brandName}
                                        data-textColor={textColor}
                                      >
                                        <img
                                          src={ad.images[0].url}
                                          alt=""
                                          onLoad={() => handleImagesLoad(index, 0)}
                                          style={{
                                            cursor: 'pointer',
                                            width: '100%',
                                            height: '100%',
                                            display: loadedImages[index][0] ? 'block' : 'none'
                                          }}
                                        />
                                      </a>
                                    )}
                                  </>
                                )}
                              </div>
                              <div
                                className="promotionsPageNew-creatives-img"
                                style={{ aspectRatio: '30/37' }}
                              >
                                {loadedImages[index] && (
                                  <>
                                    {!loadedImages[index][1] && (
                                      <Skeleton
                                        variant="rounded"
                                        width="100%"
                                        height="100%"
                                        style={{ marginBottom: '0' }}
                                      />
                                    )}
                                    {ad.images && ad.images.length > 1 && (
                                      <a
                                        data-fancybox="gallery"
                                        href={ad.images[1].url}
                                        data-primaryText={ad.primaryText}
                                        data-headline={ad.headline}
                                        data-actionButton={ad.actionButton}
                                        data-brandName={brandName}
                                        data-textColor={textColor}
                                      >
                                        <img
                                          src={ad.images[1].url}
                                          alt=""
                                          onLoad={() => handleImagesLoad(index, 1)}
                                          style={{
                                            cursor: 'pointer',
                                            width: '100%',
                                            height: '100%',
                                            display: loadedImages[index][1] ? 'block' : 'none'
                                          }}
                                        />
                                      </a>
                                    )}
                                  </>
                                )}
                              </div>
                              <div
                                className="promotionsPageNew-creatives-img"
                                style={{ aspectRatio: '177/313' }}
                              >
                                {loadedImages[index] && (
                                  <>
                                    {!loadedImages[index][2] && (
                                      <Skeleton
                                        variant="rounded"
                                        width="100%"
                                        height="100%"
                                        style={{ marginBottom: '0' }}
                                      />
                                    )}
                                    {ad.images && ad.images.length > 2 && (
                                      <a
                                        data-fancybox="gallery"
                                        href={ad.images[2].url}
                                        data-primaryText={ad.primaryText}
                                        data-headline={ad.headline}
                                        data-actionButton={ad.actionButton}
                                        data-brandName={brandName}
                                        data-textColor={textColor}
                                      >
                                        <img
                                          src={ad.images[2].url}
                                          alt=""
                                          onLoad={() => handleImagesLoad(index, 2)}
                                          style={{
                                            cursor: 'pointer',
                                            width: '100%',
                                            height: '100%',
                                            display: loadedImages[index][2] ? 'block' : 'none'
                                          }}
                                        />
                                      </a>
                                    )}
                                  </>
                                )}
                              </div>
                            </>
                          )}
                          {ad.videos && ad.videos.length > 0 && (
                            <>
                              <div
                                className="promotionsPageNew-creatives-img promotionsPageNew-creatives-video"
                                style={{ aspectRatio: '9/16' }}
                              >
                                {loadedImages[index] && (
                                  <>
                                    {!loadedImages[index][0] && (
                                      <Skeleton
                                        variant="rounded"
                                        width="100%"
                                        height="100%"
                                        style={{ marginBottom: '0' }}
                                      />
                                    )}
                                    {ad.videos && ad.videos.length > 0 && (
                                      <a
                                        data-fancybox="gallery"
                                        href={ad.videos[0].url}
                                        data-primaryText={ad.primaryText}
                                        data-headline={ad.headline}
                                        data-actionButton={ad.actionButton}
                                        data-brandName={brandName}
                                        data-textColor={textColor}
                                      >
                                        <img
                                          src={ad.videos[0].coverUrl}
                                          alt=""
                                          onLoad={() => handleImagesLoad(index, 0)}
                                          style={{
                                            cursor: 'pointer',
                                            width: '100%',
                                            height: '100%',
                                            display: loadedImages[index][0] ? 'block' : 'none'
                                          }}
                                        />
                                      </a>
                                    )}
                                  </>
                                )}
                                <svg
                                  width="30"
                                  height="30"
                                  viewBox="0 0 30 30"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M28.1275 12.5943C30.0704 13.5568 30.0704 16.4379 28.1275 17.4005L4.06828 29.3197C2.37373 30.1592 0.417969 28.8717 0.417969 26.9166L0.41797 3.07818C0.41797 1.12312 2.37372 -0.164397 4.06828 0.675108L28.1275 12.5943Z"
                                    fill="white"
                                  />
                                </svg>
                              </div>
                            </>
                          )}
                        </div>
                      </Fancybox>
                      <div className="promotionsPageNew-info">
                        <div className="promotionsPageNew-info-top">
                          <div
                            className="promotionsPageNew-info__ava"
                            style={{ background: textColor }}
                          >
                            {brandName.charAt(0).toUpperCase()}
                          </div>
                          <div className="promotionsPageNew-info-top__name">
                            <strong>{brandName}</strong>
                            <span>
                              Sponsored –
                              <svg
                                width="12"
                                height="12"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M5.99987 0C2.69145 0 0 2.69172 0 6.00013C0 9.30855 2.69145 12 5.99987 12C9.30828 12 12 9.30855 12 6.00013C12 2.69172 9.30828 0 5.99987 0ZM5.75226 7.84433C5.78608 7.94585 5.49003 8.24189 5.46467 8.25881C5.43927 8.27572 4.88948 7.97121 4.79645 7.92894C4.70338 7.88663 4.49194 7.2015 4.49194 7.2015L4.28893 7.00694C4.28893 7.00694 3.82372 6.66017 3.78141 6.64322C3.73914 6.62631 3.65456 5.97504 3.62743 5.91582C3.60034 5.8566 3.41769 5.6705 3.36696 5.63668C3.3162 5.60286 3.29084 5.02768 3.29084 5.02768C3.29084 5.02768 3.3162 4.69781 3.48536 4.45249C3.65455 4.20721 3.64607 3.78427 3.59533 3.69969C3.54458 3.61511 3.21292 3.73772 3.21292 3.73772C3.21292 3.73772 2.95639 3.61051 2.93103 3.62742L2.75944 3.30879C2.75944 3.30879 1.73755 3.23611 1.75446 3.21075C1.75446 3.21075 3.38227 0.619987 6.76091 1.00765H6.81999C7.00325 1.02128 7.17201 1.02141 7.26793 1.19137C7.28669 1.22459 7.63012 1.52587 7.62156 1.52587C7.61964 1.52587 6.68266 1.52587 6.68266 1.52587L6.48811 1.69503L7.34312 2.20577C7.22605 2.2377 6.98819 2.31186 6.82785 2.36249C6.7201 2.39654 6.62042 2.44803 6.53004 2.51581L6.19209 2.76928L5.87774 3.21758L6.33585 3.5559C6.33585 3.5559 6.86873 3.96193 6.89413 3.97883C6.91949 3.99575 7.02947 3.64048 7.02947 3.64048C7.01817 3.36698 7.0069 3.09351 6.99562 2.82001C7.0802 2.84822 7.16478 2.8764 7.24936 2.90459L7.62153 2.87077C7.62153 2.87077 7.99371 3.15836 8.03601 3.19218C8.07829 3.22603 8.24748 3.58974 8.24748 3.58974C8.24231 3.64661 8.20252 3.95744 8.27483 3.96885C8.28889 3.97107 8.30271 3.96477 8.31548 3.95857C8.44369 3.89631 8.56597 3.82356 8.68852 3.75102C8.74647 3.71667 8.87071 3.60665 8.94106 3.60665C8.96642 3.60665 8.83112 3.91116 8.81417 3.93652C8.80088 3.95648 8.48415 4.48392 8.34946 4.70829C8.30878 4.77607 8.26173 4.83624 8.20626 4.8926L7.76536 5.34064L7.91761 5.60284L7.54964 6.03837C7.51867 6.07504 7.48509 6.10943 7.44918 6.14128L7.05482 6.49098C7.05482 6.49098 6.62343 6.5925 6.59807 6.5925C6.57267 6.5925 6.25126 6.66863 6.25126 6.66863C6.25126 6.66863 5.64226 6.60941 5.55768 6.93083C5.47312 7.25226 5.71841 7.74283 5.75226 7.84433ZM10.2455 6.27549C10.3224 6.25839 10.0403 6.63447 10.0232 6.69429C10.0061 6.7541 9.71553 7.05327 9.71553 7.05327L9.2369 7.11308C9.31498 6.66614 9.6844 6.33037 10.1362 6.28846C10.1905 6.28342 10.2299 6.27894 10.2455 6.27549ZM7.52307 7.77795L7.29877 7.44599C7.28084 7.41907 7.38849 7.30243 7.38849 7.30243C7.38849 7.30243 8.24083 7.17684 8.32156 7.18579C8.4023 7.19478 8.53688 7.44599 8.53688 7.44599C8.53688 7.44599 8.24083 7.83176 8.14213 7.83176C8.04345 7.83176 7.52307 7.77795 7.52307 7.77795ZM7.74973 8.94212C7.74973 8.94212 7.64718 8.98485 7.54463 9.03615C7.44205 9.08741 7.31387 9.13014 7.29675 9.09596C7.27964 9.06178 7.20272 9.01052 7.06599 8.90794C6.92923 8.80539 6.74975 8.71135 6.65572 8.66862C6.56173 8.62592 6.34804 8.46352 6.31386 8.38659C6.2919 8.33719 6.39933 8.19001 6.41641 8.11309C6.43351 8.03617 6.40788 7.80686 6.45914 7.83177C6.51043 7.85667 6.62154 7.78979 6.73264 7.83177C6.84378 7.87377 7.0147 7.95925 7.04888 8.02761C7.0831 8.09598 7.16854 8.24983 7.26257 8.30967C7.35656 8.36949 7.52752 8.43785 7.51896 8.54896C7.51044 8.6601 7.64717 8.80539 7.64717 8.80539L7.74973 8.94212ZM7.91683 10.5412C7.4513 10.3349 7.33465 10.1016 7.37056 10.0568C7.40643 10.0119 7.70251 9.76968 7.79223 9.64405C7.88195 9.51845 8.34849 8.98912 8.34849 8.98912L8.20493 8.70203L8.60588 8.46509C8.73181 8.39069 8.87252 8.34477 9.01807 8.33065L9.40822 8.29272C9.43142 8.29043 9.4547 8.289 9.47801 8.28837L10.1069 8.27136C10.1069 8.27136 10.6784 8.12339 10.5914 8.28035C9.28113 10.6457 7.91683 10.5412 7.91683 10.5412Z"
                                  fill="#CAD4DD"
                                />
                              </svg>
                            </span>
                          </div>
                        </div>
                        <div className="promotionsPageNew-info-text">
                          <span>Primary text</span>
                          <p>{ad.primaryText}</p>
                        </div>
                        <div className="promotionsPageNew-info-text">
                          <span>Headline text</span>
                          <p>{ad.headline}</p>
                        </div>
                        <div className="promotionsPageNew-info__btn">
                          {ad.actionButton
                            .replace('_', ' ')
                            .toLowerCase()
                            .replace(/^\w/, (c) => c.toUpperCase())}
                        </div>
                      </div>
                    </>
                  ))}
                </>
              ) : (
                <>
                  <Fancybox>
                    <div className="promotionsPageNew-creatives">
                      <div
                        className="promotionsPageNew-creatives-img"
                        style={{ aspectRatio: '1/1' }}
                      >
                        {!loaded[0] && (
                          <Skeleton
                            variant="rounded"
                            width={'100%'}
                            height={'100%'}
                            style={{ marginBottom: '0' }}
                          />
                        )}

                        <a
                          data-fancybox="gallery"
                          href={promationImg[0]}
                          data-primaryText={promationPrimaryText}
                          data-headline={promationHeadlineText}
                          data-actionButton={promationAction}
                          data-brandName={brandName}
                          data-textColor={textColor}
                        >
                          <img
                            src={promationImg[0]}
                            alt=""
                            onLoad={() => handleImageLoad(0)}
                            style={{ cursor: 'pointer', display: loaded[0] ? 'block' : 'none' }}
                          />
                        </a>
                      </div>
                      <div
                        className="promotionsPageNew-creatives-img"
                        style={{ aspectRatio: '30/37' }}
                      >
                        {!loaded[1] && (
                          <Skeleton
                            variant="rounded"
                            width={'100%'}
                            height={'100%'}
                            style={{ marginBottom: '0' }}
                          />
                        )}
                        <a
                          data-fancybox="gallery"
                          href={promationImg[1]}
                          data-primaryText={promationPrimaryText}
                          data-headline={promationHeadlineText}
                          data-actionButton={promationAction}
                          data-brandName={brandName}
                          data-textColor={textColor}
                        >
                          <img
                            src={promationImg[1]}
                            alt=""
                            onLoad={() => handleImageLoad(1)}
                            style={{ cursor: 'pointer', display: loaded[1] ? 'block' : 'none' }}
                          />
                        </a>
                      </div>
                      <div
                        className="promotionsPageNew-creatives-img"
                        style={{ aspectRatio: '177/313' }}
                      >
                        {!loaded[2] && (
                          <Skeleton
                            variant="rounded"
                            width={'100%'}
                            height={'100%'}
                            style={{ marginBottom: '0' }}
                          />
                        )}
                        <a
                          data-fancybox="gallery"
                          href={promationImg[2]}
                          data-primaryText={promationPrimaryText}
                          data-headline={promationHeadlineText}
                          data-actionButton={promationAction}
                          data-brandName={brandName}
                          data-textColor={textColor}
                        >
                          <img
                            src={promationImg[2]}
                            alt=""
                            onLoad={() => handleImageLoad(2)}
                            style={{ cursor: 'pointer', display: loaded[2] ? 'block' : 'none' }}
                          />
                        </a>
                      </div>
                    </div>
                  </Fancybox>
                  <div className="promotionsPageNew-info">
                    <div className="promotionsPageNew-info-top">
                      <div
                        className="promotionsPageNew-info__ava"
                        style={{ background: textColor }}
                      >
                        {brandName.charAt(0).toUpperCase()}
                      </div>
                      <div className="promotionsPageNew-info-top__name">
                        <strong>{brandName}</strong>
                        <span>
                          Sponsored –
                          <svg
                            width="12"
                            height="12"
                            viewBox="0 0 12 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M5.99987 0C2.69145 0 0 2.69172 0 6.00013C0 9.30855 2.69145 12 5.99987 12C9.30828 12 12 9.30855 12 6.00013C12 2.69172 9.30828 0 5.99987 0ZM5.75226 7.84433C5.78608 7.94585 5.49003 8.24189 5.46467 8.25881C5.43927 8.27572 4.88948 7.97121 4.79645 7.92894C4.70338 7.88663 4.49194 7.2015 4.49194 7.2015L4.28893 7.00694C4.28893 7.00694 3.82372 6.66017 3.78141 6.64322C3.73914 6.62631 3.65456 5.97504 3.62743 5.91582C3.60034 5.8566 3.41769 5.6705 3.36696 5.63668C3.3162 5.60286 3.29084 5.02768 3.29084 5.02768C3.29084 5.02768 3.3162 4.69781 3.48536 4.45249C3.65455 4.20721 3.64607 3.78427 3.59533 3.69969C3.54458 3.61511 3.21292 3.73772 3.21292 3.73772C3.21292 3.73772 2.95639 3.61051 2.93103 3.62742L2.75944 3.30879C2.75944 3.30879 1.73755 3.23611 1.75446 3.21075C1.75446 3.21075 3.38227 0.619987 6.76091 1.00765H6.81999C7.00325 1.02128 7.17201 1.02141 7.26793 1.19137C7.28669 1.22459 7.63012 1.52587 7.62156 1.52587C7.61964 1.52587 6.68266 1.52587 6.68266 1.52587L6.48811 1.69503L7.34312 2.20577C7.22605 2.2377 6.98819 2.31186 6.82785 2.36249C6.7201 2.39654 6.62042 2.44803 6.53004 2.51581L6.19209 2.76928L5.87774 3.21758L6.33585 3.5559C6.33585 3.5559 6.86873 3.96193 6.89413 3.97883C6.91949 3.99575 7.02947 3.64048 7.02947 3.64048C7.01817 3.36698 7.0069 3.09351 6.99562 2.82001C7.0802 2.84822 7.16478 2.8764 7.24936 2.90459L7.62153 2.87077C7.62153 2.87077 7.99371 3.15836 8.03601 3.19218C8.07829 3.22603 8.24748 3.58974 8.24748 3.58974C8.24231 3.64661 8.20252 3.95744 8.27483 3.96885C8.28889 3.97107 8.30271 3.96477 8.31548 3.95857C8.44369 3.89631 8.56597 3.82356 8.68852 3.75102C8.74647 3.71667 8.87071 3.60665 8.94106 3.60665C8.96642 3.60665 8.83112 3.91116 8.81417 3.93652C8.80088 3.95648 8.48415 4.48392 8.34946 4.70829C8.30878 4.77607 8.26173 4.83624 8.20626 4.8926L7.76536 5.34064L7.91761 5.60284L7.54964 6.03837C7.51867 6.07504 7.48509 6.10943 7.44918 6.14128L7.05482 6.49098C7.05482 6.49098 6.62343 6.5925 6.59807 6.5925C6.57267 6.5925 6.25126 6.66863 6.25126 6.66863C6.25126 6.66863 5.64226 6.60941 5.55768 6.93083C5.47312 7.25226 5.71841 7.74283 5.75226 7.84433ZM10.2455 6.27549C10.3224 6.25839 10.0403 6.63447 10.0232 6.69429C10.0061 6.7541 9.71553 7.05327 9.71553 7.05327L9.2369 7.11308C9.31498 6.66614 9.6844 6.33037 10.1362 6.28846C10.1905 6.28342 10.2299 6.27894 10.2455 6.27549ZM7.52307 7.77795L7.29877 7.44599C7.28084 7.41907 7.38849 7.30243 7.38849 7.30243C7.38849 7.30243 8.24083 7.17684 8.32156 7.18579C8.4023 7.19478 8.53688 7.44599 8.53688 7.44599C8.53688 7.44599 8.24083 7.83176 8.14213 7.83176C8.04345 7.83176 7.52307 7.77795 7.52307 7.77795ZM7.74973 8.94212C7.74973 8.94212 7.64718 8.98485 7.54463 9.03615C7.44205 9.08741 7.31387 9.13014 7.29675 9.09596C7.27964 9.06178 7.20272 9.01052 7.06599 8.90794C6.92923 8.80539 6.74975 8.71135 6.65572 8.66862C6.56173 8.62592 6.34804 8.46352 6.31386 8.38659C6.2919 8.33719 6.39933 8.19001 6.41641 8.11309C6.43351 8.03617 6.40788 7.80686 6.45914 7.83177C6.51043 7.85667 6.62154 7.78979 6.73264 7.83177C6.84378 7.87377 7.0147 7.95925 7.04888 8.02761C7.0831 8.09598 7.16854 8.24983 7.26257 8.30967C7.35656 8.36949 7.52752 8.43785 7.51896 8.54896C7.51044 8.6601 7.64717 8.80539 7.64717 8.80539L7.74973 8.94212ZM7.91683 10.5412C7.4513 10.3349 7.33465 10.1016 7.37056 10.0568C7.40643 10.0119 7.70251 9.76968 7.79223 9.64405C7.88195 9.51845 8.34849 8.98912 8.34849 8.98912L8.20493 8.70203L8.60588 8.46509C8.73181 8.39069 8.87252 8.34477 9.01807 8.33065L9.40822 8.29272C9.43142 8.29043 9.4547 8.289 9.47801 8.28837L10.1069 8.27136C10.1069 8.27136 10.6784 8.12339 10.5914 8.28035C9.28113 10.6457 7.91683 10.5412 7.91683 10.5412Z"
                              fill="#CAD4DD"
                            />
                          </svg>
                        </span>
                      </div>
                    </div>
                    <div className="promotionsPageNew-info-text">
                      <span>Primary text</span>
                      <p>{promationPrimaryText}</p>
                    </div>
                    <div className="promotionsPageNew-info-text">
                      <span>Headline text</span>
                      <p>{promationHeadlineText}</p>
                    </div>
                    <div className="promotionsPageNew-info__btn">
                      {promationAction
                        .replace('_', ' ')
                        .toLowerCase()
                        .replace(/^\w/, (c) => c.toUpperCase())}
                    </div>
                  </div>
                </>
              )}
            </div>
            {blockStatus == 'PENDING' && role != 'support' && (
              <div className="promotionsPage-info-action">
                <div className="promotionsPage-info-action__edit" onClick={handleOpenEdit}>
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clipPath="url(#clip0_12803_72802)">
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M9.26286 6.03429L4.74805 10.5491C4.57954 10.7176 4.47337 10.9384 4.44697 11.1753L4.14928 13.8463L6.82264 13.5505C7.05977 13.5242 7.2809 13.418 7.4496 13.2493L11.9637 8.73516L9.26286 6.03429ZM12.8123 7.88663L10.1114 5.18576L11.3943 3.9029C11.8043 3.49285 12.4691 3.49285 12.8792 3.9029L14.0951 5.11884C14.5052 5.52889 14.5052 6.19372 14.0951 6.60377L12.8123 7.88663ZM13.7277 3.05437C12.849 2.17569 11.4244 2.17569 10.5457 3.05437L3.89952 9.70058C3.53843 10.0617 3.31092 10.5348 3.25435 11.0424L2.89437 14.2724C2.84114 14.75 3.24458 15.1538 3.72226 15.1009L6.95465 14.7432C7.46279 14.6869 7.93662 14.4593 8.29813 14.0978L14.9437 7.45229C15.8223 6.57361 15.8223 5.14899 14.9437 4.27031L13.7277 3.05437Z"
                        fill="black"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_12803_72802">
                        <rect width="15" height="15" fill="white" transform="translate(1.5 1.5)" />
                      </clipPath>
                    </defs>
                  </svg>
                  Edit
                </div>

                <>
                  <div
                    className={`promotionsPage-info-action__clear ${buttonLoading ? 'loading' : ''}`}
                    onClick={skipAds}
                  >
                    Skip
                  </div>
                  <div
                    className={`promotionsPage-info-action__reject ${buttonLoading ? 'loading' : ''}`}
                    onClick={handleOpenReject}
                  >
                    Reject
                  </div>
                  <div
                    className={`promotionsPage-info-action__approve ${buttonLoading ? 'loading' : ''}`}
                    onClick={handleClick}
                  >
                    {buttonLoading ? (
                      <>
                        <i></i>
                        <i></i>
                        <i></i>
                      </>
                    ) : (
                      <>Approve</>
                    )}
                  </div>
                </>
              </div>
            )}
            {(blockStatus == 'SKIPED' || blockStatus == 'ERROR' || blockStatus == 'PROCESSING') && (
              <div className="promotionsPage-info-action">
                <>
                  <div className="promotionsPage-info-action__edit" onClick={handleOpenEdit}>
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clipPath="url(#clip0_12803_72802)">
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M9.26286 6.03429L4.74805 10.5491C4.57954 10.7176 4.47337 10.9384 4.44697 11.1753L4.14928 13.8463L6.82264 13.5505C7.05977 13.5242 7.2809 13.418 7.4496 13.2493L11.9637 8.73516L9.26286 6.03429ZM12.8123 7.88663L10.1114 5.18576L11.3943 3.9029C11.8043 3.49285 12.4691 3.49285 12.8792 3.9029L14.0951 5.11884C14.5052 5.52889 14.5052 6.19372 14.0951 6.60377L12.8123 7.88663ZM13.7277 3.05437C12.849 2.17569 11.4244 2.17569 10.5457 3.05437L3.89952 9.70058C3.53843 10.0617 3.31092 10.5348 3.25435 11.0424L2.89437 14.2724C2.84114 14.75 3.24458 15.1538 3.72226 15.1009L6.95465 14.7432C7.46279 14.6869 7.93662 14.4593 8.29813 14.0978L14.9437 7.45229C15.8223 6.57361 15.8223 5.14899 14.9437 4.27031L13.7277 3.05437Z"
                          fill="black"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_12803_72802">
                          <rect
                            width="15"
                            height="15"
                            fill="white"
                            transform="translate(1.5 1.5)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                    Edit
                  </div>
                  <div
                    className={`promotionsPage-info-action__reject ${buttonLoading ? 'loading' : ''}`}
                    onClick={handleOpenReject}
                  >
                    Reject
                  </div>
                  <div
                    className={`promotionsPage-info-action__approve ${buttonLoading ? 'loading' : ''}`}
                    onClick={handleClick}
                  >
                    {buttonLoading ? (
                      <>
                        <i></i>
                        <i></i>
                        <i></i>
                      </>
                    ) : (
                      <>Approve</>
                    )}
                  </div>
                </>
              </div>
            )}
            {blockStatus != 'PENDING' && (
              <div className="promotionsPageNew-bottom">
                {blockStatus == 'REJECTED' && (
                  <>
                    {' '}
                    <div className="promotionsPage-info-action-text">
                      <p style={{ color: '#F43535' }}>
                        Rejected by {adminEmail} on {promationRejectedAt}
                      </p>
                      <span>
                        Unacceptable content on the creative...{' '}
                        <i onClick={handleOpenRejectView}>View Description</i>
                      </span>
                    </div>
                  </>
                )}
                {blockStatus == 'APPROVED' && (
                  <>
                    <div className="promotionsPage-info-action-text green">
                      <p style={{ color: '#17CC37' }}>
                        Approved by {adminEmail} on {promationRejectedAt}
                      </p>
                    </div>
                  </>
                )}
              </div>
            )}
          </div>

          {snackbarOpen && (
            <Snackbar
              snackbarOpen={snackbarOpen}
              setSnackbarOpen={setSnackbarOpen}
              snackbarText={snackbarText}
              snackbarCount={snackbarCount}
              setSnackbarCount={setSnackbarCount}
            />
          )}
          <Modal
            keepMounted
            open={openBlock}
            onClose={handleCloseBlock}
            aria-labelledby="keep-mounted-modal-title"
            aria-describedby="keep-mounted-modal-description"
            className="modal"
          >
            <Box sx={styleBlock} className="modal-container">
              <div className="promotionsPage-errorPupup-close" onClick={handleCloseBlock}>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M6 6L18 18" stroke="black" strokeWidth="1.6" strokeLinecap="round" />
                  <path d="M18 6L6 18" stroke="black" strokeWidth="1.6" strokeLinecap="round" />
                </svg>
              </div>
              <div className="promotionsPage-errorPupup">
                <svg
                  width="81"
                  height="80"
                  viewBox="0 0 81 80"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="40.5" cy="40" r="40" fill="#F2F4F6" />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M44.4719 23.6367C46.2586 23.6351 47.9727 24.3433 49.2372 25.6056L54.8795 31.2378C56.144 32.5001 56.8553 34.2129 56.8569 35.9996L56.864 43.9719C56.8656 45.7586 56.1574 47.4727 54.8951 48.7372L49.2629 54.3795C48.0006 55.644 46.2878 56.3553 44.5011 56.3569L36.5288 56.364C34.7421 56.3656 33.028 55.6574 31.7635 54.3951L26.1212 48.7629C24.8567 47.5006 24.1454 45.7878 24.1438 44.0011L24.1367 36.0288C24.1351 34.2421 24.8433 32.528 26.1056 31.2635L31.7378 25.6212C33.0001 24.3567 34.7129 23.6454 36.4996 23.6438L44.4719 23.6367ZM38.1905 32.2227C38.1123 30.8933 39.1692 29.7724 40.5009 29.7724C41.8325 29.7724 42.8895 30.8933 42.8113 32.2227L42.2333 42.0479C42.1794 42.9652 41.4198 43.6815 40.5009 43.6815C39.582 43.6815 38.8224 42.9652 38.7684 42.0479L38.1905 32.2227ZM40.5009 45.3178C39.1453 45.3178 38.0463 46.4168 38.0463 47.7724C38.0463 49.128 39.1453 50.2269 40.5009 50.2269C41.8565 50.2269 42.9554 49.128 42.9554 47.7724C42.9554 46.4168 41.8565 45.3178 40.5009 45.3178Z"
                    fill="#F43535"
                  />
                </svg>

                <div className="promotionsPage-errorPupup__title">
                  When publishing the advertisement, an error occurred
                </div>
                <div className="promotionsPage-errorPupup__text">{errorText}</div>
              </div>
            </Box>
          </Modal>

          <Modal
            keepMounted
            open={openReject}
            onClose={handleCloseReject}
            aria-labelledby="keep-mounted-modal-title"
            aria-describedby="keep-mounted-modal-description"
            className="modal"
          >
            <Box sx={styleReject} className="modal-container">
              <div className="promotionsPage-errorPupup-close" onClick={handleCloseReject}>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M6 6L18 18" stroke="black" strokeWidth="1.6" strokeLinecap="round" />
                  <path d="M18 6L6 18" stroke="black" strokeWidth="1.6" strokeLinecap="round" />
                </svg>
              </div>
              <div className="promotionsPage-errorPupup">
                <div className="promotionsPage-errorPupup__title">
                  Describe why you reject this campaign
                </div>
                <label>
                  <span>Reason of reject</span>
                  <div className="promotionsPage-errorPupup__textarea">
                    <TextareaAutosize
                      value={reason}
                      onChange={handleReasonChange}
                      maxLength={120}
                      placeholder="Enter reason"
                    />
                    <i>{reason.length}/120</i>
                  </div>
                </label>
                <label>
                  <span>Description of reject</span>
                  <div className="promotionsPage-errorPupup__textarea">
                    <TextareaAutosize
                      value={description}
                      onChange={handleDescriptionChange}
                      maxLength={500}
                      placeholder="Describe reason of reject"
                    />
                    <i>{description.length}/500</i>
                  </div>
                </label>
                <div className="promotionsPage-errorPupup-action">
                  <div
                    className={`promotionsPage-errorPupup__cancel ${rejectLoading ? 'loading' : ''}`}
                    onClick={handleCloseReject}
                  >
                    Cancel
                  </div>
                  <div
                    className={`promotionsPage-errorPupup__reject ${rejectLoading ? 'loading' : ''}`}
                    onClick={handleReject}
                  >
                    {rejectLoading ? (
                      <>
                        <i></i>
                        <i></i>
                        <i></i>
                      </>
                    ) : (
                      <>Reject</>
                    )}
                  </div>
                </div>
              </div>
            </Box>
          </Modal>

          <Modal
            keepMounted
            open={openEdit}
            onClose={handleCloseEdit}
            aria-labelledby="keep-mounted-modal-title"
            aria-describedby="keep-mounted-modal-description"
            className="modal"
          >
            <Box sx={styleReject} className="modal-container">
              <div className="promotionsPage-errorPupup-close" onClick={handleCloseEdit}>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M6 6L18 18" stroke="black" strokeWidth="1.6" strokeLinecap="round" />
                  <path d="M18 6L6 18" stroke="black" strokeWidth="1.6" strokeLinecap="round" />
                </svg>
              </div>
              <div className="promotionsPage-errorPupup">
                {/* <div className="promotionsPage-errorPupup__title">
                                Describe why you reject this campaign
                            </div> */}
                <label style={{ marginBottom: 0 }}>
                  <span>New Website link</span>
                  <input
                    type="text"
                    name="email"
                    value={urlEdit}
                    onChange={handleChange}
                    placeholder="Enter your url"
                  />
                  {errorUrl && (
                    <div style={{ color: 'red', fontSize: '12rem', marginTop: '8rem' }}>
                      {errorUrl}
                    </div>
                  )}
                </label>

                <div className="promotionsPage-errorPupup-action">
                  <div
                    className={`promotionsPage-errorPupup__cancel ${rejectLoading ? 'loading' : ''}`}
                    onClick={handleCloseEdit}
                  >
                    Cancel
                  </div>
                  <div
                    className={`promotionsPage-errorPupup__confirm ${rejectLoading ? 'loading' : ''}`}
                    onClick={handleSaveEdit}
                  >
                    {rejectLoading ? (
                      <>
                        <i></i>
                        <i></i>
                        <i></i>
                      </>
                    ) : (
                      <>Confirm</>
                    )}
                  </div>
                </div>
              </div>
            </Box>
          </Modal>

          {blockStatus == 'REJECTED' && (
            <Modal
              keepMounted
              open={openRejectView}
              onClose={handleCloseRejectView}
              aria-labelledby="keep-mounted-modal-title"
              aria-describedby="keep-mounted-modal-description"
              className="modal"
            >
              <Box sx={styleReject} className="modal-container">
                <div className="promotionsPage-errorPupup-close" onClick={handleCloseRejectView}>
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M6 6L18 18" stroke="black" strokeWidth="1.6" strokeLinecap="round" />
                    <path d="M18 6L6 18" stroke="black" strokeWidth="1.6" strokeLinecap="round" />
                  </svg>
                </div>
                <div className="promotionsPage-errorPupup">
                  <div className="promotionsPage-errorPupup__title">
                    Rejected by {adminEmail} on {promationRejectedAt}
                  </div>
                  <label>
                    <span>Reason of reject</span>
                    {promationRejectTitle && <p>{promationRejectTitle}</p>}
                  </label>
                  <label style={{ marginBottom: '0' }}>
                    <span>Description of reject</span>
                    {promationRejectTitle && <p>{promationRejectDescription}</p>}
                  </label>
                </div>
              </Box>
            </Modal>
          )}

          <Modal
            keepMounted
            open={open}
            onClose={handleClose}
            aria-labelledby="keep-mounted-modal-title"
            aria-describedby="keep-mounted-modal-description"
            className="modal"
            onClick={handleClose}
          >
            <Box sx={style} className="modal-container">
              <div
                className="creatives-modal-close"
                // onClick={handleClose}
              >
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M10 10L26 26" stroke="white" strokeWidth="2" strokeLinecap="round" />
                  <path d="M26 10L10 26" stroke="white" strokeWidth="2" strokeLinecap="round" />
                </svg>
              </div>
              <div
                className="creatives-modal__img"
                style={{
                  display: 'grid',
                  gridTemplateColumns: 'repeat(1,1fr)',
                  alignItems: 'center',
                  gridGap: '24rem'
                }}
              >
                <img src={img || ''} onClick={(e) => e.stopPropagation()} alt="" />
                {/* <img src={process.env.PUBLIC_URL + '/img/creative1.jpg'} onClick={(e) => e.stopPropagation()} alt="" />
                   <img src={process.env.PUBLIC_URL + '/img/creative2.jpg'} onClick={(e) => e.stopPropagation()} alt="" /> */}
                {/* <img src={`${imgModal}`} alt="" /> */}
              </div>
            </Box>
          </Modal>
        </div>
      )}
    </>
  );
};

export default PromotionsPageBlockNew;
